var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.74,120.77c1.08-2,74.61-85.57,148.32,0C181.06,120.77,109.77,181.41,32.74,120.77Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 106.49,
    cy: 109.3,
    r: 26.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 106.49,
    cy: 109.3,
    r: 13.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.74,120.77s11.7-64.42,74.7-64.67c31.5-.13,51.94,15,63,30.15"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/EYE.96a3761409ff9d42442b16343ef16665.svg";
export { ForwardRef as ReactComponent };